module.exports = {
          srcSet: __webpack_public_path__ + "659fa8c4.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "659fa8c4.jpg",width: 330,height: 220}],
          src: __webpack_public_path__ + "659fa8c4.jpg",
          toString:function(){return __webpack_public_path__ + "659fa8c4.jpg"},
          
          width: 330,
          height: 220
        }